// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_go-a";
export var fulfillmentFormRail = "_go-9";
export var headerTitleRow = "_go-c";
export var orderDetailsWrapper = "_go-7";
export var orderLinkTrigger = "_go-2";
export var paymentInformationGrid = "_go-h";
export var paymentSummaryColumn = "_go-i";
export var shipmentContainer = "_go-b";
export var shipmentDetailsMainPane = "_go-8";
export var shipmentNavigationCard = "_go-5";
export var shipmentNavigationRail = "_go-3";
export var shipmentNavigationRailHeader = "_go-4";
export var shipmentSummaryFact = "_go-e";
export var shipmentSummaryGrid = "_go-d";
export var shipmentSummaryMetadataRow = "_go-f";
export var shipmentSummaryTags = "_go-g";
export var shipmentWorkspace = "_go-0";
export var shipmentWorkspaceContent = "_go-6";
export var shipmentWorkspaceHeader = "_go-1";